const modalTypes = {
    ABSENTEE_BID: 'ABSENTEE_BID',
    ADD_CREDIT_CARD: 'ADD_CREDIT_CARD',
    ADD_SEARCH_ALERT: 'ADD_SEARCH_ALERT',
    BID_LIMIT_EXCEEDED: 'BID_LIMIT_EXCEEDED',
    BUY_NOW: 'BUY_NOW',
    CATALOG_ANNOUNCEMENT: 'CATALOG_ANNOUNCEMENT',
    CHANGE_PASSWORD: 'CHANGE_PASSWORD',
    CLASSIC_BIDDING_CONSOLE: 'CLASSIC_BIDDING_CONSOLE',
    CLEAR_CACHE: 'CLEAR_CACHE',
    COMPLETE_ACCOUNT: 'COMPLETE_ACCOUNT',
    CONFIRM_CONSIGNMENT: 'CONFIRM_CONSIGNMENT',
    CONFIRM_PASSWORD: 'CONFIRM_PASSWORD',
    CONSENT: 'CONSENT',
    DELETE_ACCOUNT_CONFIRMATION: 'DELETE_ACCOUNT_CONFIRMATION',
    DESCRIPTION: 'DESCRIPTION',
    DOWNLOAD_MOBILE: 'DOWNLOAD_MOBILE',
    ENABLE_NOTIFICATIONS: 'ENABLE_NOTIFICATIONS',
    EXCLUDE_HOUSE: 'EXCLUDE_HOUSE',
    FEEDBACK: 'FEEDBACK',
    FOLLOW_SEARCH: 'FOLLOW_SEARCH',
    FORGOT_PASSWORD: 'FORGOT_PASSWORD',
    HEALTHCHECK: 'HEALTHCHECK',
    INSTALL_FLASH: 'INSTALL_FLASH',
    ITEM_PAGE_FIRST_TIME: 'ITEM_PAGE_FIRST_TIME',
    LIVE_BID: 'LIVE_BID',
    LOGIN: 'LOGIN',
    MAKE_OFFER: 'MAKE_OFFER',
    NONE: 'NONE',
    PREFERENCES: 'PREFERENCES',
    REGISTER_FOR_AUCTION: 'REGISTER_FOR_AUCTION',
    REPORT_REVIEW: 'REPORT_REVIEW',
    RETRACT_BID: 'RETRACT_BID',
    REVIEWS: 'REVIEWS',
    SEND_SELLER_CONSIGNMENT_MESSAGE: 'SEND_SELLER_CONSIGNMENT_MESSAGE',
    SEND_SELLER_MESSAGE: 'SEND_SELLER_MESSAGE',
    SET_PASSWORD: 'SET_PASSWORD',
    SHIPPING_AND_PAYMENT: 'SHIPPING_AND_PAYMENT',
    SIGN_UP: 'SIGN_UP',
    SMS_CONFIRMATION: 'SMS_CONFIRMATION',
    TAX_EXEMPT: 'TAX_EXEMPT',
    TERMS: 'TERMS',
    WAITING_FOR_APPROVAL: 'WAITING_FOR_APPROVAL',
} as const;

export default modalTypes;
